import React from 'react';

import { Container, Divider, Typography } from '@mui/material';
import { isNil, noop } from 'lodash';
import { useLocation } from 'react-router-dom';
import { BottomSafeArea } from '../../../components';
import { createScopedI18n } from '../../../i18n/i18n';
import UserEditPage from './change_email';
import { ChangePasswordPage } from './change_password';
import { ChangePhoneNumberPage } from './change_phone_number';

const userEditI18n = createScopedI18n('pages.user_edit');

const SECTION_IDS = {
  changeEmail: 'change_email',
  changePassword: 'change_password',
  changePhoneNumber: 'change_phone_number',
};

const SectionTitle = ({ id, label }: { id: string; label: string }) => (
  <Typography id={id} variant="h6" sx={{ scrollMarginTop: 64, padding: 2 }}>
    {label}
  </Typography>
);

const UserEditLayout = () => {
  const { hash } = useLocation();

  React.useEffect(() => {
    if (isNil(hash)) {
      return noop;
    }

    // Wait for layout to settle (and child forms to mount) before scrolling.
    const id = hash.slice(1);
    const handle = window.requestAnimationFrame(() => {
      const element = document.getElementById(id);
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    return () => window.cancelAnimationFrame(handle);
  }, [hash]);

  return (
    <Container maxWidth="sm" disableGutters>
      <SectionTitle id={SECTION_IDS.changeEmail} label={userEditI18n('section_change_email_title')} />
      <UserEditPage />

      <Divider sx={{ marginY: 1 }} />

      <SectionTitle id={SECTION_IDS.changePassword} label={userEditI18n('section_change_password_title')} />
      <ChangePasswordPage />

      <Divider sx={{ marginY: 1 }} />

      <SectionTitle id={SECTION_IDS.changePhoneNumber} label={userEditI18n('section_change_phone_number_title')} />
      <ChangePhoneNumberPage />

      <BottomSafeArea />
    </Container>
  );
};

export default UserEditLayout;
